module.exports = __webpack_public_path__ + "static/netflix-6144ed55ae5115fdd914c5ac08ff49ac.png";